export default __webpack_public_path__ + "static/media/img1.331dc7b2.jpg";